import React from 'react';
import { connect } from 'react-redux';
import { getSignersRequest } from 'Domains/TradeAgreementsSellOut/redux/actions';
import GenerateFileForm from './GenerateFileForm/GenerateFileForm';

function LayoutTradeAgreementsGenerate(props) {
  const { territoryId, clientInfo } = props;
  return (
    <>
      <GenerateFileForm territoryId={territoryId} clientInfo={clientInfo} />
    </>
  );
}

function mapStateToProps(state) {
  return {
    territoryId:
      state?.TRADE_AGREEMENTS_SELLOUT?.infoForAgreement?.territoryInfo?.territoryId ?? false,
    clientInfo: state?.TRADE_AGREEMENTS_SELLOUT?.infoForAgreement?.clientInfo ?? false,
    year: state?.TRADE_AGREEMENTS_SELLOUT?.query?.year,
    lineId: state?.TRADE_AGREEMENTS_SELLOUT?.query?.lineId,
  };
}

export default connect(mapStateToProps, { getSignersRequest })(LayoutTradeAgreementsGenerate);
